import Immutable   from 'immutable'
import { HasMany } from './associations'

export default class AssociationFinder
  constructor: (@associations) ->

  belongingEntitiesOf: (entity) ->
    handled  = new Immutable.Set([entity])
    entities = @directBelongingEntitiesOf(entity)

    while entities.subtract(handled).size > 0
      handled  = handled.union(entities)
      entities = entities.map((entity) => @directBelongingEntitiesOf(entity)).flatten()

    handled.union(entities)

  directBelongingEntitiesOf: (entity) ->
    associations = @associations.forModel(entity.constructor).ofType(HasMany)
    entitySets   = associations.map (assoc) -> entity.associations[assoc.name].entitySet()

    entitySets.flatten()
